//adds count numbers to vedette news view section
jQuery(document).ready(function() {

  const vedette = document.querySelector('.view-display-id-article_vedette');
  if (vedette) {
    const vedetteNews = vedette.querySelectorAll('.views-row');

    vedetteNews.forEach((newsItem,index) => {
      const countDisplay = document.createElement('div');
      countDisplay.setAttribute('class', 'vedette-count me-3')
      const countElement = document.createElement('h3');
      const elementWrapper = document.createElement('div');
      const newsItemChild = newsItem.querySelectorAll('.views-field');

      newsItemChild.forEach(child => {
        elementWrapper.appendChild(child);
      })

      index++;
      countElement.innerHTML = index.toString();
      countDisplay.appendChild(countElement);
      newsItem.appendChild(countDisplay);
      newsItem.appendChild(elementWrapper);
    })
  }
});

(function ($, once) {
  Drupal.behaviors.dispatchLoadedAjaxContentInnovation = {
    attach: function (context, settings) {
      $(once('ajaxViewsAction', 'document')).ajaxSuccess(function (event, data) {
        if (drupalSettings && drupalSettings.views && drupalSettings.views.ajaxViews) {
          const ajaxViews = drupalSettings.views.ajaxViews;
          Object.keys(ajaxViews || {}).forEach(function (i) {
            if (ajaxViews[i]['view_name'] == 'sollio_articles') {
              setTimeout(function () {
                const event = new Event('relatedLoaded');
                const eventReloaded = new Event('search_reloaded');
                document.dispatchEvent(event);
                document.dispatchEvent(eventReloaded);
              }, 5);
            }
          });
        }
      });
    }
  }
})(jQuery, once);
